import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import Login from './pages/Login'
import AdminDashboard from './pages/AdminDashboard'
import SalesLeads from './pages/SalesLeads'
import LeadDetail from './pages/LeadDetail'
import NewLead from './pages/NewLead'
import UserManagement from './pages/UserManagement'
import EditUser from './pages/EditUser'
import ProtectedRoute from './components/ProtectedRoute'
import InitialSetup from './pages/InitialSetup'
import Profile from './pages/Profile'
import PublicLeadForm from './pages/PublicLeadForm'
import ThankYouPage from './pages/ThankYouPage'
import ChangePassword from './pages/ChangePassword'
import { Toaster } from 'sonner'
import Layout from './components/Layout'

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/setup" element={<InitialSetup />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          
          {/* Public Routes */}
          <Route path="/lead-form/:userId" element={<PublicLeadForm />} />
          <Route path="/lead-form/:userId/thanks" element={<ThankYouPage />} />
          
          {/* Password Change Route */}
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole="admin">
                <Layout>
                  <AdminDashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute requiredRole="admin">
                <Layout>
                  <UserManagement />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users/:userId"
            element={
              <ProtectedRoute requiredRole="admin">
                <Layout>
                  <EditUser />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Profile Route */}
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Layout>
                  <Profile />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Sales Routes */}
          <Route
            path="/leads"
            element={
              <ProtectedRoute>
                <Layout>
                  <SalesLeads />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/leads/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <NewLead />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/leads/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <LeadDetail />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App 